import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/Library/Icon";

import styles from "./ShareLink.css";

export default function ShareLink({ shareLinkConfig, onClick, className }) {
  return (
    <a
      target="_blank"
      href={shareLinkConfig.url}
      aria-label={shareLinkConfig.description}
      className={classNames(styles.root, className)}
      onClick={onClick}
    >
      <Icon
        name={shareLinkConfig.name}
        path="img"
        description={shareLinkConfig.description}
        className={styles.icon}
      />
    </a>
  );
}

ShareLink.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  shareLinkConfig: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};
